/* eslint-disable camelcase */
import DtoUserBookmark from 'administration/components/user/dto/DtoUserBookmark'
import { DECLARATION_STATUS, LOCAL_EXPLOITATIONS_FILTERS, emptyFilterExploitations } from 'agriAdministration/constants/AgriConstants'
import Checkbox from 'components/forms/Checkbox'
import { push } from '@lagunovsky/redux-react-router'
import DtoExploitationExportFull from 'exploitations/dto/DtoExploitationExportFull'
import ExportAction from 'export/actions/ExportAction'
import { groupBy, keys, lowerCase, orderBy, uniq, includes } from 'lodash'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import DtoManagementUnit from 'referencial/components/managementUnit/dto/DtoManagementUnit'
import WatershedDto from 'referencial/components/watershed/dto/WatershedDto'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import { formatData } from 'utils/ExportDataUtil'
import AgriAction from '../../agriAdministration/actions/AgriAction'
import ActionComponent from '../../components/ActionComponent'
import ProgressCard from 'components/card/ProgressCard'
import HomeAction from '../../home/actions/HomeAction'
import ContributorAction from '../../referencial/components/contributor/actions/ContributorAction'
import ContributorItem from '../../referencial/components/contributor/dto/ContributorItem'
import { nbPerPageLabel } from '../../referencial/constants/ReferencialConstants'
import DtoSandreCode from '../../referencial/dto/DtoSandreCode'
import { getLocalStorageJson, setLocalStorageJson } from '../../utils/FormUtils'
import { getLogin } from '../../utils/SettingUtils'
import { formatPhone, getI18nTitleData, searchAllCharacters } from '../../utils/StringUtil'
import NewFolderModal from './modal/NewFolderModal'
import ExploitationsFilterPanel from './panels/ExploitationsFilterPanel'
import PropTypes from 'prop-types'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import SimpleTabList from 'components/list/SimpleTabList'
import { STATION_LIST } from 'station/constants/StationConstants'
import SimpleKeyFigurePanel from 'components/keyFigures/SimpleKeyFigurePanel'
import { Accordion, AccordionDetails, AccordionSummary, Grid, Icon, Stack, Typography } from '@mui/material'
import CurrentSurveysPanel from 'survey/components/panels/CurrentSurveysPanel'
import NumberField from 'components/forms/NumberField'
import ExportFileModal from 'components/modal/ExportFileModal'
import Other from 'components/actions/Other'
import { ALIGN, CardTable, NewTable } from 'components/datatable/NewTable'
import { getDate } from 'utils/DateUtil'

const formatDateExport = 'DDMMYYYY'

const headersTable = ['codification', 'sampler', 'city', 'structureType', 'nbPtsPrel', 'progression', 'domestic', 'agri', 'nonAgri', 'adjourned', 'shut']

const headersExport = ['updateDate', 'activityEndDate', 'codification', 'structureType', 'organism', 'civility', 'name', 'address', 'additionnalAddress', 'inseeCode',
    'postalCode', 'city', 'phoneTel', 'mobile', 'fax', 'email', 'comments', 'contributors', 'siret', 'pacage', 'octagri_aura', 'octagri_local', 'muse', 'agence',
    'domestic', 'agri', 'nonAgri', 'adjourned', 'shut']

const headersExportAgency = ['codification', 'structureType', 'civility', 'name', 'address', 'additionnalAddress', 'inseeCode',
    'postalCode', 'city', 'phoneTel', 'mobile', 'fax', 'email', 'siret', 'pacage', 'agence', 'advancement']

class ExploitationsListApp extends ActionComponent {
    constructor(props) {
        super(props)
        const localExploitationsFilters = getLocalStorageJson(LOCAL_EXPLOITATIONS_FILTERS) || emptyFilterExploitations
        this.state = {
            dataLoaded: false,
            filter: {
                ...localExploitationsFilters,
            },
            settings: {
                exportDate: moment().year(),
                startDate: null,
                endDate: null,
            },
            histoStartDate: moment().startOf('year').valueOf(),
            histoEndDate: moment().endOf('year').valueOf(),
            nbMonthsBefore: 6,
            nbMonthsAfter: 4,
            openExportModal: false,
            openModalNewFolder: false,
            progress: 0,
            data: [],
        }
    }

    componentDidMount() {
        this.props.setTitle([{
            title: i18n.folders,
            href: 'dossiers',
        }, {
            title: i18n.dashboard,
            href: 'dossiers/dashboard',
        }])
        this.props.fetchExploitationsExportFullData().then(() => {
            const { exploitationsExportFullData, accountUser } = this.props
            this.setState({ dataLoaded: true, data: this.getData(exploitationsExportFullData) }, () => {
                const exportAction = {
                    other: (
                        <Other
                            className='clickable'
                            tooltip={i18n.export}
                            icon='file_download'
                            onClick={() => this.setState({ openExportModal: true })}
                        />
                    ),
                }
                if (accountUser.isAdmin === '1' || accountUser.metadata === '1') {
                    this.setActions({
                        new: () => this.toggleModalNewFolder(),
                        other: exportAction,
                    })
                } else {
                    this.setActions({ other: exportAction })
                }
            })
        })
    }

    toggleModalNewFolder = () => {
        this.setState(({ openModalNewFolder }) => ({
            openModalNewFolder: !openModalNewFolder,
        }))
    }

    getFilteredData = () => {
        const { userBookmarks } = this.props
        const { data, filter } = this.state
        const { searchValue, structureTypes, procedureTypes, city, managementUnit, subManagementUnit, watershed, filters, domestic,
            agri, nonAgri, adjourned, shut, sampleType, sampleNature, accompanyingAquiferCode, droughtSector, organism } = filter
        const login = getLogin()
        const favoritesFiltered = filters === 1 ? data.filter((e) => userBookmarks.find((b) => b.login === login && b.stationType === 10 && parseInt(b.identifiant) === e.idExploitation)) : data
        const cityFilteredData = city ? favoritesFiltered.filter((e) => (city === e.inseeCode) || e.link_points.find((p) => p.cityCode === city)) : favoritesFiltered
        const ugeFilteredData = managementUnit ? cityFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.managementCode === parseInt(managementUnit))) : cityFilteredData
        const subUgeFilteredData = subManagementUnit ? ugeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.subManagementCode === parseInt(subManagementUnit))) : ugeFilteredData
        const watershedFilteredData = watershed ? subUgeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.bvCode === parseInt(watershed))) : subUgeFilteredData
        const sampleTypeFilteredData = sampleType ? watershedFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.sampleType === parseInt(sampleType))) : watershedFilteredData
        const sampleNatureFilteredData = sampleNature ? sampleTypeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.sampleNature === parseInt(sampleNature))) : sampleTypeFilteredData
        const accompanyingAquiferCodeFilteredData = accompanyingAquiferCode ? sampleNatureFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.accompanyingAquiferCode === parseInt(accompanyingAquiferCode))) : sampleNatureFilteredData
        const droughtSectorFilteredData = droughtSector ? accompanyingAquiferCodeFilteredData.filter(({ link_points }) => link_points && link_points.find((l) => l.droughtSector === parseInt(droughtSector))) : accompanyingAquiferCodeFilteredData
        const structureFilteredData = structureTypes?.length ? droughtSectorFilteredData.filter(({ structureCode }) => structureTypes.includes(structureCode)) : droughtSectorFilteredData
        const procedureFilteredData = procedureTypes?.length ? structureFilteredData.filter(({ procedureType }) => procedureTypes.includes(procedureType)) : structureFilteredData
        const organismFilteredData = organism ? procedureFilteredData.filter((e) => e.organism === organism) : procedureFilteredData
        const checkBoxFilteredData = (() => {
            if ((domestic && agri && nonAgri && adjourned && shut) || (!domestic && !agri && !nonAgri && !adjourned && !shut)) {
                return organismFilteredData
            }
            return organismFilteredData.filter(d => (domestic && d.domestic.sortValue) || (agri && d.agri.sortValue) ||
            (nonAgri && d.nonAgri.sortValue) ||(adjourned && d.adjourned.sortValue) ||
            (shut && d.shut.sortValue),
            )
        })()
        const includesValue = searchAllCharacters(searchValue || '')
        return checkBoxFilteredData.filter(i => this.getHashMateriel(i).includes(lowerCase(searchValue)) || this.getHash(i).includes(includesValue))
    }

    getHashMateriel = (exploitation) => {
        return lowerCase(exploitation.link_points.reduce((acc, p) => `${acc ? `${acc}, ` : ''}${p.code ? `${p.code}, ` : ''}${p.materiels || ''}`, ''))
    }

    getHash = (exploitation) => {
        return searchAllCharacters([...headersExport, 'legalRepSampler', 'legalRepExploit', 'contactsExploit'].map(key => exploitation.exportData[key] || ''))
    }

    getAdvancementIcon = (statusCode) => {
        if (statusCode === DECLARATION_STATUS.VALIDATED) {
            return 'check_circle'
        } else if (statusCode === DECLARATION_STATUS.VALIDATED_BY_ADMIN) {
            return 'check_circle_outline'
        } else if (statusCode === DECLARATION_STATUS.FINALIZED_BY_AGRI) {
            return 'done'
        } else if (statusCode === DECLARATION_STATUS.STARTED) {
            return 'play_circle_outline'
        } else if (includes(DECLARATION_STATUS.NOT_STARTED, statusCode)) {
            return 'hourglass_full'
        }
        return null
    }

    getAdvancementTooltip = (statusCode) => {
        if (statusCode === DECLARATION_STATUS.VALIDATED) {
            return i18n.validated
        } else if (statusCode === DECLARATION_STATUS.VALIDATED_BY_ADMIN) {
            return i18n.validatedByAdmin
        } else if (statusCode === DECLARATION_STATUS.FINALIZED_BY_AGRI) {
            return i18n.finalizedByUser
        } else if (statusCode === DECLARATION_STATUS.STARTED) {
            return i18n.inProgress
        } else if (includes(DECLARATION_STATUS.NOT_STARTED, statusCode)) {
            return i18n.notStarted
        }
        return null
    }

    getExport = (data, headers, type, fileName) => {
        const orderedData = orderBy(data, 'codification')
        const dataWithHeader = orderedData.length > 0 ? [{ ...orderedData[0], headers }, ...orderedData.slice(1)] : []
        this.props.export(formatData(dataWithHeader), type, fileName)
    }

    getConsosExportContent = () => {
        const { settings } = this.state
        const { startDate, endDate } = settings
        return (
            <Grid container>
                <Grid size={12}>
                    <SimpleDatePicker
                        label={i18n.startDate}
                        value={startDate}
                        onChange={d => this.setState({
                            settings: {
                                ...settings,
                                startDate: d,
                            },
                        })}
                        calendarPosition='left'
                    />
                </Grid>
                <Grid size={12}>
                    <SimpleDatePicker
                        label={i18n.endDate}
                        value={endDate}
                        onChange={d => this.setState({
                            settings: {
                                ...settings,
                                endDate: d,
                            },
                        })}
                        calendarPosition='left'
                    />
                </Grid>
            </Grid>
        )
    }

    getVolumesHistoExportContent = () => {
        const { histoStartDate, histoEndDate, nbMonthsBefore, nbMonthsAfter } = this.state
        return (
            <Grid container spacing={1}>
                <Grid size={6}>
                    <SimpleDatePicker
                        label={i18n.startDate}
                        value={histoStartDate}
                        min={moment().year(2000).valueOf()}
                        max={histoEndDate ?? moment().endOf('year').valueOf()}
                        onChange={d => this.setState({ histoStartDate: d })}
                    />
                </Grid>
                <Grid size={6}>
                    <SimpleDatePicker
                        label={i18n.endDate}
                        value={histoEndDate}
                        min={histoStartDate ?? moment().year(2000).valueOf()}
                        max={moment().endOf('year').valueOf()}
                        onChange={d => this.setState({ histoEndDate: d })}
                    />
                </Grid>
                <Grid size={6}>
                    <NumberField
                        title={i18n.nbMonthsBefore}
                        value={nbMonthsBefore}
                        onChange={d => this.setState({ nbMonthsBefore: d })}
                        tooltip={i18n.nbMonthsBeforeExplaination}
                    />
                </Grid>
                <Grid size={6}>
                    <NumberField
                        title={i18n.nbMonthsAfter}
                        value={nbMonthsAfter}
                        onChange={d => this.setState({ nbMonthsAfter: d })}
                        tooltip={i18n.nbMonthsAfterExplaination}
                    />
                </Grid>
            </Grid>
        )
    }

    getFullExportData = () => {
        const { exploitationsExportFullData, contributors } = this.props
        const filteredData = this.getFilteredData()
        return exploitationsExportFullData.filter((d) => filteredData.find((e) => e.idExploitation === d.idExploitation)).map((e) => {
            return {
                ...e,
                organism: e.organism ? contributors.find((c) => c.id === e.organism)?.name : '',
                contributors: e.contactsExploit,
                domestic: e.domestic ? i18n.yes : i18n.no,
                agri: e.agri ? i18n.yes : i18n.no,
                nonAgri: e.nonAgri ? i18n.yes : i18n.no,
                adjourned: !e.link_points.find((lp) => !lp.endDate || lp.endDate > moment().valueOf()) ? i18n.yes : i18n.no,
                shut: e.folderClosed ? i18n.yes : i18n.no,
            }
        })
    }

    getModalNewFolder = () => {
        const { openModalNewFolder } = this.state
        return openModalNewFolder && (
            <NewFolderModal
                open={openModalNewFolder}
                onCancel={this.toggleModalNewFolder}
                onValidate={this.onValidateFolder}
            />
        )
    }

    onValidateFolder = (exploitation, intervenant) => {
        this.setState({ dataLoaded: false })
        this.props.createContributor(intervenant, 'noRedirection').then((intervenantId) => {
            if (intervenantId) {
                this.props.fetchContributors()
                const exploitationToCreate = {
                    ...exploitation,
                    operatorCode: intervenantId,
                }
                this.props.createExploitation(exploitationToCreate).then((idExploitation) => {
                    if (idExploitation) {
                        this.setState({ dataLoaded: true })
                        this.props.push(`/dossiers/${idExploitation}/dashboard`)
                    }
                })
            } else {
                this.setState({ dataLoaded: true })
            }
        })
        this.setState({ openModalNewFolder: false })
    }

    getData = (exploitations) => {
        return exploitations.map((e) => {
            const adjourned = !e.link_points.find((lp) => !lp.endDate || lp.endDate > moment().valueOf())
            const advancement = (e.lastDeclarationStep * 100) / 4
            return {
                ...e,
                exportData: e,
                codification: { value: e.codification },
                structureType: { value: e.structureType },
                nbPtsPrel: { value: e.nbPtsPrel },
                sampler: {
                    value: e.name,
                    tooltip: (
                        <Stack>
                            <Typography>{`${i18n.email} : ${e.email || ''}`}</Typography>
                            <Typography>{`${i18n.phoneTel} : ${formatPhone(e.phoneTel) || ''}`}</Typography>
                            <Typography>{`${i18n.mobile} : ${formatPhone(e.mobile) || ''}`}</Typography>
                        </Stack>
                    ),
                },
                samplerName: { value: e.name },
                city: { value: `${e.city || ''} ${e.inseeCode ? `[${e.inseeCode}]` : ''}` },
                progression: {
                    value: e.lastDeclarationId && <Icon sx={{ fontSize: '1.7rem' }}>{this.getAdvancementIcon(e.lastDeclarationStatus)}</Icon>,
                    sortValue: e.lastDeclarationStatus,
                    tooltip: e.lastDeclarationStatus && `${this.getAdvancementTooltip(e.lastDeclarationStatus)} (${i18n.survey} ${e.lastDeclarationYear})`,
                    align: ALIGN.CENTER,
                },
                advancement: { value: `${(e.lastDeclarationStep && (advancement > 100 ? 100 : advancement) || 0)} %` },
                domestic: {
                    value: e.domestic ? (
                        <Checkbox
                            checked
                            disabled
                        />
                    ) : false,
                    sortValue: e.domestic || false,
                },
                agri: {
                    value: e.agri ? (
                        <Checkbox
                            checked
                            disabled
                        />
                    ) : false,
                    sortValue: e.agri || false,
                },
                nonAgri: {
                    value: e.nonAgri ? (
                        <Checkbox
                            checked
                            disabled
                        />
                    ) : false,
                    sortValue: e.nonAgri || false,
                },
                adjourned: {
                    value: adjourned ? (
                        <Checkbox
                            checked
                            disabled
                        />
                    ) : false,
                    sortValue: adjourned,
                },
                shut: {
                    value: e.folderClosed ? (
                        <Checkbox
                            checked
                            disabled
                        />
                    ) : false,
                    sortValue: e.folderClosed || false,
                },
            }
        })
    }

    onValidateFilter = (filter) => {
        setLocalStorageJson(LOCAL_EXPLOITATIONS_FILTERS, filter)
        this.setState({ filter })
    }

    getExportModal = () => {
        const { openExportModal, histoStartDate, histoEndDate, nbMonthsBefore, nbMonthsAfter, settings: { startDate, endDate } } = this.state
        const data = [{
            name: i18n.exportFull,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => this.getExport(this.getFullExportData(), headersExport, 'xlsx', `${i18n.folders}_${i18n.exportFull}`),
            },
            {
                type: i18n.csv,
                callback: () => this.getExport(this.getFullExportData(), headersExport, 'csv', `${i18n.folders}_${i18n.exportFull}`),
            }],
        }, {
            name: `${i18n.exportName} ${i18n.waterAgency}`,
            formats: [{
                type: i18n.exportXLSX,
                callback: () => this.getExport(this.getFilteredData(), headersExportAgency, 'xlsx', `${i18n.folders}_${i18n.agencyExport}`),
            },
            {
                type: i18n.csv,
                callback: () => this.getExport(this.getFilteredData(), headersExportAgency, 'csv', `${i18n.folders}_${i18n.agencyExport}`),
            }],
        }, {
            name: `${i18n.exportName} ${i18n.consos}`,
            settingsContent: this.getConsosExportContent(),
            formats: [{
                type: i18n.exportXLSX,
                callback: () => this.props.exportExploitationsConsos({ idsExploitations: this.getFilteredData().map((e) => e.idExploitation), startDate, endDate }, 'xlsx', `${i18n.folders}_${i18n.consos}_${getDate(startDate, formatDateExport)}-${getDate(endDate, formatDateExport)}`),
            },
            {
                type: i18n.csv,
                callback: () => this.props.exportExploitationsConsos({ idsExploitations: this.getFilteredData().map((e) => e.idExploitation), startDate, endDate }, 'csv', `${i18n.folders}_${i18n.consos}_${getDate(startDate, formatDateExport)}-${getDate(endDate, formatDateExport)}`),
            }],
        }, {
            name: `${i18n.exportName} ${i18n.index} ${i18n.weekly}`,
            settingsContent: this.getConsosExportContent(),
            formats: [{
                type: i18n.exportXLSX,
                callback: () => this.props.exportIndexWeekly({ idsExploitations: this.getFilteredData().map((e) => e.idExploitation), startDate, endDate }, 'xlsx', `${i18n.folders}_${i18n.index}_${i18n.weekly}_${getDate(startDate, formatDateExport)}-${getDate(endDate, formatDateExport)}`),
            },
            {
                type: i18n.csv,
                callback: () => this.props.exportIndexWeekly({ idsExploitations: this.getFilteredData().map((e) => e.idExploitation), startDate, endDate }, 'csv', `${i18n.folders}_${i18n.index}_${i18n.weekly}_${getDate(startDate, formatDateExport)}-${getDate(endDate, formatDateExport)}`),
            }],
        }, {
            name: `${i18n.exportName} ${i18n.volumes} ${i18n.historic}`,
            settingsContent: this.getVolumesHistoExportContent(),
            formats: [{
                type: i18n.exportXLSX,
                callback: () => this.props.exportVolumesHisto(histoStartDate, histoEndDate, nbMonthsBefore, nbMonthsAfter, 'xlsx', `${i18n.folders}_${i18n.volumes}_${i18n.historic}_${moment(histoStartDate).format('DD-MM-YYYY')}_${moment(histoEndDate).format('DD-MM-YYYY')}`),
            },
            {
                type: i18n.csv,
                callback: () => this.props.exportVolumesHisto(histoStartDate, histoEndDate, nbMonthsBefore, nbMonthsAfter, 'csv', `${i18n.folders}_${i18n.volumes}_${i18n.historic}_${moment(histoStartDate).format('DD-MM-YYYY')}_${moment(histoEndDate).format('DD-MM-YYYY')}`),
            }],
        }]

        return openExportModal && (
            <ExportFileModal
                open={openExportModal}
                onClose={() => this.setState({ openExportModal: false })}
                data={data}
            />
        )
    }

    render() {
        const { dataLoaded, data } = this.state
        const { contributorsIndex } = this.props

        const filteredData = dataLoaded ? this.getFilteredData() : []
        const groupedData = groupBy(filteredData, 'organism')

        return (
            <>
                <Grid container className='padding-bottom-1' spacing={1}>
                    <Grid size={9}>
                        <CurrentSurveysPanel />
                    </Grid>
                    <Grid size={3}>
                        <SimpleKeyFigurePanel
                            data={[{
                                title: i18n.folders,
                                value: data.length,
                            }, {
                                title: i18n.adjourneds,
                                value: data.filter(e => e.adjourned.sortValue).length,
                            }, {
                                title: i18n.shut,
                                value: data.filter(e => e.shut.sortValue).length,
                            }, {
                                title: i18n.pointsPrelevement,
                                value: uniq(data.flatMap(e => e.link_points.map((p) => p.idInstallation))).length,
                            }]} round noMargin
                        />
                    </Grid>
                </Grid>
                <ExploitationsFilterPanel className='padding-1' onValidate={this.onValidateFilter} />
                <div className='margin-top-1'>
                    {dataLoaded ? (
                        <SimpleTabList
                            defaultTab={STATION_LIST}
                            noPadding
                            tabs={[
                                {
                                    constant: STATION_LIST,
                                    label: i18n.table,
                                    icon: 'list',
                                },
                                {
                                    constant: 'referent',
                                    label: i18n.organism,
                                    icon: 'person',
                                },
                            ]}
                        >
                            {tab => (
                                <>
                                    {tab === STATION_LIST && (
                                        <CardTable
                                            title={filteredData.length > 1 ? i18n.folders : i18n.folder}
                                            rows={filteredData}
                                            headers={headersTable}
                                            onClickRow={s => this.props.push(`/dossiers/${s.idExploitation}/dashboard`)}
                                            headersLabel={{
                                                structureType: i18n.structure,
                                                nbPtsPrel: i18n.nbPts,
                                                folderClosed: i18n.shut,
                                                nonAgri: <span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nonAgriWrap}</span>,
                                            }}
                                            defaultSort={{ column: 'codification' }}
                                            rowsPerPageOptions={nbPerPageLabel}
                                        />
                                    )}
                                    {tab === 'referent' && (
                                        <Grid container spacing={1} direction='column' sx={{ padding: '1rem' }}>
                                            {keys(groupedData).map((organismId, i) => {
                                                const datas = groupedData[organismId]
                                                return (
                                                    <Accordion defaultExpanded={i === 0} key={organismId}>
                                                        <AccordionSummary>
                                                            <span style={{ fontSize: 18 }}>{organismId !== 'undefined' ? (contributorsIndex[organismId] || {}).name : i18n.unknown}</span>
                                                            <span style={{ fontSize: 18, fontWeight: 'normal' }}>&nbsp;{`(${datas.length} ${getI18nTitleData(i18n.element, i18n.elements, datas)})`}</span>
                                                        </AccordionSummary>
                                                        <AccordionDetails sx={{ padding: 0 }}>
                                                            <NewTable
                                                                rows={datas}
                                                                rowsPerPageOptions={nbPerPageLabel}
                                                                headers={headersTable}
                                                                onClickRow={s => this.props.push(`/dossiers/${s.idExploitation}/dashboard`)}
                                                                headersLabel={{
                                                                    structureType: i18n.structure,
                                                                    nbPtsPrel: i18n.nbPts,
                                                                    folderClosed: i18n.shut,
                                                                    nonAgri: <span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nonAgriWrap}</span>,
                                                                }}
                                                                defaultSort={{ column: 'codification' }}
                                                            />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                )
                                            })}
                                        </Grid>
                                    )}
                                </>
                            )}
                        </SimpleTabList>
                    ) : <ProgressCard indeterminate withMessage round />}
                </div>
                {this.getModalNewFolder()}
                {this.getExportModal()}
            </>
        )
    }
}

ExploitationsListApp.propTypes = {
    exploitationsExportFullData: PropTypes.arrayOf(PropTypes.instanceOf(DtoExploitationExportFull)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorItem)),
    contributorsIndex: PropTypes.objectOf(PropTypes.instanceOf(ContributorItem)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    watersheds: PropTypes.arrayOf(PropTypes.instanceOf(WatershedDto)),
    managementUnits: PropTypes.arrayOf(PropTypes.instanceOf(DtoManagementUnit)),
    userBookmarks: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserBookmark)),
    push: PropTypes.func,
}

const mapStateToProps = (store) => {
    return {
        exploitationsExportFullData: store.AgriReducer.exploitationsExportFullData,
        contributors: store.ContributorReducer.contributors,
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        watersheds: store.WatershedReducer.watersheds,
        managementUnits: store.ManagementUnitReducer.managementUnits,
        userBookmarks: store.UserReducer.userBookmarks,
        accountUser: store.AccountReducer.accountUser,
    }
}

const mapDispatchToProps = {
    push,
    fetchExploitationsExportFullData: AgriAction.fetchExploitationsExportFullData,
    createExploitation: AgriAction.createExploitation,
    setTitle: HomeAction.setTitle,
    createContributor: ContributorAction.createContributor,
    fetchContributors: ContributorAction.fetchContributors,
    export: ExportAction.export,
    exportExploitationsConsos: ExportAction.exportExploitationsConsos,
    exportIndexWeekly: ExportAction.exportIndexWeekly,
    exportVolumesHisto: ExportAction.exportVolumesHisto,
    warning: ToastrAction.warning,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExploitationsListApp)
